//  UC campus indices
export const CAMPUS_BERKELEY = 1;
export const CAMPUS_DAVIS = 2;
export const CAMPUS_IRVINE = 3;
export const CAMPUS_UCLA = 4;
export const CAMPUS_MERCED = 5;
export const CAMPUS_RIVERSIDE = 6;
export const CAMPUS_SAN_DIEGO = 7;
export const CAMPUS_SANTA_BARBARA = 8;
export const CAMPUS_SANTA_CRUZ = 9;
//  Categories of student housing circumstances
export const HOUSING_ON_CAMPUS = 1;
export const HOUSING_OFF_CAMPUS = 2;
export const HOUSING_COMMUTER = 3;
//  Default value of select based components
export const SELECT_NULL_CHECK = -1;
//  Residency location of a student
export const RESIDENCY_NONE = 0;
export const RESIDENCY_CALIFORNIA = 1;
export const RESIDENCY_OTHER = 2;
//  Indices used in ATTENDANCE_COSTS.js
export const COSTS_DIRECT_TUITION = 1;
export const COSTS_DIRECT_CAMPUS_FEES = 2;
export const COSTS_DIRECT_HOUSING_AND_MEALS = 3;
export const COSTS_DIRECT_HEALTH_INSURANCE = 4;
export const COSTS_INDIRECT_HOUSING_AND_MEALS = 5;
export const COSTS_INDIRECT_BOOKS_AND_SUPPLIES = 6;
export const COSTS_INDIRECT_PERSONAL_AND_TRANSPORTATION = 7;
export const SELF_HELP = 8;
export const NON_RESIDENT_SCHOLARSHIP = 9;
//  Indices for self help values for California residents
export const SELF_HELP_DEBT_FREE = 1;
export const SELF_HELP_RANGE_LOW = 2;
export const SELF_HELP_RANGE_HIGH = 3;
//  Scholarship range values for non-residents
export const NON_RESIDENT_SCHOLARSHIP_LOW = 1;
export const NON_RESIDENT_SCHOLARSHIP_HIGH = 2;
//  Indices for lookup of separate types of costs in GetCosts.js
export const INDEX_DIRECT = 1;
export const INDEX_INDIRECT = 2;
//  Possible calues of student dependency
export const STATUS_DEPENDENT = 1;
export const STATUS_INDEPENDENT = 2;
//  Indication of student having dependents
export const HAS_DEPENDENTS_NO = 2;
export const HAS_DEPENDENTS_YES = 1;
//  Where parental income is earned for dependent students
export const PARENT_INCOME_EARNED_BY_NONE = 1;
export const PARENT_INCOME_EARNED_BY_ONE = 2;
export const PARENT_INCOME_EARNED_BY_BOTH = 3;
//  Indices of parent marital status
export const PARENT_MARITAL_STATUS_SINGLE = 1;
export const PARENT_MARITAL_STATUS_MARRIED = 2;
//  Indices of student marital status
export const STUDENT_MARITAL_STATUS_SINGLE = 1;
export const STUDENT_MARITAL_STATUS_MARRIED = 2;
//  Potential error tests for status, housing, residency
export const ERROR_STATUS = -1;
export const ERROR_HOUSING = -1;
export const ERROR_RESIDENCY = -1;